import BackgroundImageComponent from '@components/common/background-image'
import Footer from '@components/common/footer'
import NavBar from '@components/common/navbar'
import AllSupportYouNeed from '@components/teacher-lp/all-the-support-you-need'
import ApplicationProcess from '@components/teacher-lp/application-process'
import Benefits from '@components/teacher-lp/benefits'
import DiverseFold from '@components/teacher-lp/diverse-fold'
import EligibilityCriteria from '@components/teacher-lp/eligibilityCriteria'
import Faq from '@components/teacher-lp/faq'
import FirstFold from '@components/teacher-lp/first-fold'
import SettingUpYourVirtualClassroom from '@components/teacher-lp/setting-up-classroom'
import ThirdFold from '@components/teacher-lp/third-fold'
import UnmatchedEarnings from '@components/teacher-lp/unmatched-earnings'
import AuthModal from '@containers/competitions/auth-modal.dynamic'
import { useSessionContext } from '@contexts/session'
import useDetectCountry from '@hooks/useDetectCountry'
import useStoreUTMParams from '@hooks/useStoreUTMParam'
import { teachPage } from '@lib/seo'
import { t } from '@lingui/macro'
import { NextSeo } from 'next-seo'
import Router from 'next/router'
import { useState } from 'react'

const Teach = () => {
  const [isOpen, setIsOpen] = useState(false)

  const { loggedIn } = useSessionContext()

  const handleBecomeTeacher = () => {
    if (loggedIn) return Router.push('/dashboard/')
    setIsOpen(true)
  }

  useStoreUTMParams()
  const { countryCode } = useDetectCountry({
    isDeterminedViaSystemTimezoneOnly: true,
  })
  const earnings = countryCode === 'IN' ? '₹50,000' : '$1,000'
  return (
    <>
      <NextSeo {...teachPage} />
      <AuthModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        redirectionUrl="/dashboard/"
        isUserTeacher
      />
      <NavBar
        isSticky={true}
        customCTAonClick={handleBecomeTeacher}
        customCTAText={t`Become a teacher`}
      />
      <FirstFold
        earnings={earnings}
        handleBecomeTeacher={handleBecomeTeacher}
      />
      <Benefits />
      <ThirdFold handleBecomeTeacher={handleBecomeTeacher} />
      <UnmatchedEarnings
        countryCode={countryCode}
        handleBecomeTeacher={handleBecomeTeacher}
      />
      <AllSupportYouNeed handleBecomeTeacher={handleBecomeTeacher} />
      <DiverseFold />
      <EligibilityCriteria handleBecomeTeacher={handleBecomeTeacher} />
      <ApplicationProcess handleBecomeTeacher={handleBecomeTeacher} />
      <SettingUpYourVirtualClassroom
        handleBecomeTeacher={handleBecomeTeacher}
      />
      <div className="relative">
        <BackgroundImageComponent
          image="/images/teacher-lp/c.png"
          top={0}
          left={0}
          width={30}
        />
        <Faq earnings={earnings} />
      </div>
      <Footer />
    </>
  )
}

// TODO: Remove once getInitialProps is removed from _app.tsx
export const getStaticProps = async () => {
  return {
    props: {},
  }
}

export default Teach
